import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { StatusAcceptanceType } from '../../store/constants';
import { Tracking } from '../../store/models';
import {
  IconColor,
  IconSize,
  IconType,
  S_CODE_ICONS,
  SHORT_DISPLAY_DATE_FORMAT,
  DISPLAY_DATE_FORMAT,
  SCode,
  IconNames,
} from '../../common/constants';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { DateWithTimezoneComponent } from '../timezone/date-with-timezone.component';
import { TooltipAlertComponent } from '../tooltip/alert/tooltip-alert.component';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-delivery-status-tracking-status',
  imports: [CommonModule, IntrackFeatureModule, TranslateModule, DateWithTimezoneComponent, TooltipAlertComponent, SvgIconComponent],
  templateUrl: './delivery-status-tracking-status.component.html',
  styleUrls: ['./delivery-status-tracking-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryStatusTrackingStatusComponent {
  @Input() statuses: Tracking[];
  @Input() isTimezoneAvailable = false;

  iconType = IconType;
  iconSize = IconSize;
  iconColor = IconColor;
  sCodeIcons: Map<SCode, IconNames> = S_CODE_ICONS;
  shortDateFormat = SHORT_DISPLAY_DATE_FORMAT;
  dateFormat = DISPLAY_DATE_FORMAT;
  acceptanceType = StatusAcceptanceType;
}
